import { AngularFirestore, AngularFirestoreCollection, DocumentReference } from '@angular/fire/firestore';
import { FirebaseDaoBase } from '../table/daos/firebase-dao-base';
import { PropertyType } from "../product/PropertyType";

export class PropertyTypeDao extends FirebaseDaoBase<any> {
  
  constructor(public firestore: AngularFirestore) {
    super();
  }
  
  public getCollection(): AngularFirestoreCollection {
    const collection =  this.firestore.collection(`propertyTypes`);
    return collection;
  }
  
  public addPropertyType(propertyType: PropertyType): Promise<DocumentReference> {
    return this.getCollection().add(propertyType);
  }
}